import React from "react";
import {
    ResponsiveContainer,
    LineChart,
    Line,
    Tooltip,
    CartesianGrid,
    Legend,
} from "recharts";
import PropTypes from "prop-types";
import "./SummaryValueTile.scss";
import { chartColors, defaultLineProps, tooltipContentStyle, tooltipItemStyle, tooltipLabelStyle } from "./ChartStyles";

const SummaryValueTile = ({
    title = "Cemaco Total Sales",
    total = 862636.75,
    currency = "$",
    submetrics = [
        { label: "Units sold", value: null },
        { label: "Total volume", value: "+0.8% than last month" },
    ],
    trendData = [
        { month: "Jan", value: 540000 },
        { month: "Feb", value: 580000 },
        { month: "Mar", value: 610000 },
        { month: "Apr", value: 590000 },
        { month: "May", value: 620000 },
        { month: "Jun", value: 630000 },
    ],
    lineColor = "#4CC9F0",
    showGrid = true,
}) => {
    const formattedTotal = `${currency}${total.toLocaleString("en-US")}`;

    return (
        <div
            className="summary-value-tile d-flex justify-content-between align-items-center p-4"
            style={{ width: `100%`, height: `100%` }}
        >
            {/* Left side - Summary */}
            <div className="tile-summary text-start">
                <h2 className="tile-total mb-2">{formattedTotal}</h2>
                <p className="tile-title mb-2">{title}</p>

                {submetrics.map((item, idx) => (
                    <div
                        key={idx}
                        className="tile-submetric d-flex justify-content-between align-items-center"
                    >
                        <div className="d-flex align-items-center">
                            {idx === 0 && (
                                <i className="bi bi-graph-up me-2 text-muted small"></i>
                            )}
                            <span className="text-muted small">{item.label}</span>
                        </div>
                        {item.value && (
                            <span className="tile-submetric-value small text-muted">
                                {item.value}
                            </span>
                        )}
                    </div>
                ))}
            </div>

            {/* Right side - Mini chart */}
            <div className="tile-chart">
                <ResponsiveContainer>
                    <LineChart data={trendData}>
                        {showGrid && <CartesianGrid strokeDasharray="3 3" />}
                        <Tooltip
                            formatter={(value) => [`$${value.toLocaleString()}`, "Sales"]}
                            labelFormatter={(label) => `Month: ${label}`}
                            contentStyle={tooltipContentStyle}
                            itemStyle={tooltipItemStyle}
                            labelStyle={tooltipLabelStyle}
                        />

                        <Line
                            {...defaultLineProps}
                            dataKey="value"
                            stroke={chartColors.accent}
                        />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

SummaryValueTile.propTypes = {
    title: PropTypes.string,
    total: PropTypes.number,
    currency: PropTypes.string,
    submetrics: PropTypes.array,
    trendData: PropTypes.array,
    width: PropTypes.number,
    height: PropTypes.number,
    lineColor: PropTypes.string,
    showGrid: PropTypes.bool,
};

export default SummaryValueTile;
